var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpb-flex",style:(`--kpb-flex-direction: ${_vm.flexDirection}; --kpb-flex-wrap: ${_vm.flexWrap}; --kpb-flex-justify-content: ${_vm.justifyContent}; --kpb-flex-align-items: ${_vm.alignItems}; --kpb-flex-align-content: ${_vm.alignContent}; --kpb-flex-gap: ${_vm.gap}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }